<ng-container *transloco="let t;">
  <p-dialog [header]="''" [(visible)]="visible" [modal]="true" [style]="{width: '70vw'}" [closeOnEscape]="false" [closable]="false">
    <app-loader [loading]="loading"></app-loader>
    <ng-container *ngIf="loading !== true">
      <p [innerHtml]="content"></p>
      <hr>
      <p class="p-mt-4 p-mb-4"><p-checkbox value="accepted" [(ngModel)]="accepted" [binary]="true"></p-checkbox> {{ t('privacy.accept_to_proceed') }}</p>
    </ng-container>
    <ng-template pTemplate="footer">
      <ng-container *ngIf="loading !== true">
        <button pButton (click)="hide()" type="button" aria-label="{{ t('common.labels.cancel') }}" [label]="t('common.labels.cancel')" [disabled]="(submitting === true) ? true : null" class="p-button-secondary p-button-outlined"></button>
        <button *ngIf="submitting !== true" pButton (click)="save()" type="button" aria-label="{{ t('common.labels.save') }}" [label]="t('common.labels.save')" [disabled]="(accepted !== true) ? true : null" class="p-button-success" autofocus></button>
        <button *ngIf="submitting === true" pButton type="button" aria-label="{{ t('common.labels.save') }}" [label]="t('common.labels.save')" [disabled]="true" icon="pi pi-spin pi-spinner" class="p-button-success"></button>
      </ng-container>
    </ng-template>
  </p-dialog>
</ng-container>
